/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a volume to scale the recipe.`)
};

const es_buf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un volumen para escalar la receta.`)
};

const de_buf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie ein Volumen ein, um das Rezept zu skalieren.`)
};

const nl_buf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een volume in om het recept te schalen.`)
};

const fr_buf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un volume pour adapter la recette.`)
};

const it_buf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un volume per scalare la ricetta.`)
};

const pt_br2_buf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um volume para dimensionar a receita.`)
};

const pt_buf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um volume para escalar a receita.`)
};

const ja_buf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`量を入力してレシピをスケーリングしてください。`)
};

const zh_buf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入体积以放大配方。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_hint", locale)
	if (locale === "en") return en_buf_hint(inputs)
	if (locale === "es") return es_buf_hint(inputs)
	if (locale === "de") return de_buf_hint(inputs)
	if (locale === "nl") return nl_buf_hint(inputs)
	if (locale === "fr") return fr_buf_hint(inputs)
	if (locale === "it") return it_buf_hint(inputs)
	if (locale === "pt-BR") return pt_br2_buf_hint(inputs)
	if (locale === "pt") return pt_buf_hint(inputs)
	if (locale === "ja") return ja_buf_hint(inputs)
	return zh_buf_hint(inputs)
};